import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

import styled from 'styled-components';
import { Title } from '../title';
import { Button } from '../button';
export var ModalBackdrop = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  opacity:.5;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100%;\n  height: 100vh;\n  background-color: #000;\n"])));
export var ModalComponent = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  overflow: auto;\n  pointer-events: auto;\n"])));
export var ModalDialog = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  max-width: ", "px;\n  width: 100%;\n  max-height: 100%;\n"])), function (_ref) {
  var width = _ref.width;
  return width || 360;
});
export var ModalContent = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin: 0;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  outline: 0;\n  background-color: #fff;\n  width: 100%;\n  min-height: 100vh;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  overflow: hidden;\n  \n  @media (min-width: ", "){\n    margin: 40px auto;\n    border-radius: 8px;\n    width: auto;\n    min-height: 0;\n    overflow: visible;\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.screen.smMin;
});
export var ModalHeader = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  padding: ", ";\n  \n  @media (min-width: ", "){\n    padding: ", ";\n    padding: ", ";\n  }\n"])), function (_ref3) {
  var skin = _ref3.skin,
      theme = _ref3.theme;
  return theme.modal[skin || 'with-form'].header.mobile.padding;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.screen.smMin;
}, function (_ref5) {
  var skin = _ref5.skin,
      theme = _ref5.theme;
  return theme.modal[skin || 'with-form'].header.desktop.padding;
}, function (_ref6) {
  var skin = _ref6.skin,
      theme = _ref6.theme;
  return theme.modal[skin || 'with-form'].header.desktop.padding;
});
export var Heading = styled(Title)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: ", ";\n  line-height: ", ";\n  text-align: ", ";\n  color: ", ";\n  ", "\n\n  @media (min-width: ", "){\n    font-size: ", ";\n    line-height: ", ";\n    text-align: ", ";\n    color: ", ";\n    ", "\n  }\n"])), function (_ref7) {
  var skin = _ref7.skin,
      theme = _ref7.theme;
  return theme.modal[skin || 'with-form'].header.mobile.title.fontSize;
}, function (_ref8) {
  var skin = _ref8.skin,
      theme = _ref8.theme;
  return theme.modal[skin || 'with-form'].header.mobile.title.lineHeight;
}, function (_ref9) {
  var skin = _ref9.skin,
      theme = _ref9.theme;
  return theme.modal[skin || 'with-form'].header.mobile.textAlign;
}, function (_ref10) {
  var skin = _ref10.skin,
      theme = _ref10.theme;
  return theme.modal[skin || 'with-form'].header.mobile.color;
}, function (_ref11) {
  var skin = _ref11.skin;
  return !skin || skin === 'with-form' ? 'width: 90vw;' : "";
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.screen.smMin;
}, function (_ref13) {
  var skin = _ref13.skin,
      theme = _ref13.theme;
  return theme.modal[skin || 'with-form'].header.desktop.title.fontSize;
}, function (_ref14) {
  var skin = _ref14.skin,
      theme = _ref14.theme;
  return theme.modal[skin || 'with-form'].header.desktop.title.lineHeight;
}, function (_ref15) {
  var skin = _ref15.skin,
      theme = _ref15.theme;
  return theme.modal[skin || 'with-form'].header.desktop.textAlign;
}, function (_ref16) {
  var skin = _ref16.skin,
      theme = _ref16.theme;
  return theme.modal[skin || 'with-form'].header.desktop.color;
}, function (_ref17) {
  var skin = _ref17.skin;
  return !skin || skin === 'with-form' ? 'width: auto;' : "";
});
export var SubTitle = styled.p(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  margin: 16px 0 0 0;\n  font-size: ", ";\n  line-height: ", ";\n  text-align: ", ";\n  color: ", ";\n\n  @media (min-width: ", "){\n    font-size: ", ";\n    line-height: ", ";\n    text-align: ", ";\n    color: ", ";\n  }\n"])), function (_ref18) {
  var skin = _ref18.skin,
      theme = _ref18.theme;
  return theme.modal[skin || 'with-form'].header.mobile.subtitle.fontSize;
}, function (_ref19) {
  var skin = _ref19.skin,
      theme = _ref19.theme;
  return theme.modal[skin || 'with-form'].header.mobile.subtitle.lineHeight;
}, function (_ref20) {
  var skin = _ref20.skin,
      theme = _ref20.theme;
  return theme.modal[skin || 'with-form'].header.mobile.textAlign;
}, function (_ref21) {
  var skin = _ref21.skin,
      theme = _ref21.theme;
  return theme.modal[skin || 'with-form'].header.mobile.color;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.screen.smMin;
}, function (_ref23) {
  var skin = _ref23.skin,
      theme = _ref23.theme;
  return theme.modal[skin || 'with-form'].header.desktop.subtitle.fontSize;
}, function (_ref24) {
  var skin = _ref24.skin,
      theme = _ref24.theme;
  return theme.modal[skin || 'with-form'].header.desktop.subtitle.lineHeight;
}, function (_ref25) {
  var skin = _ref25.skin,
      theme = _ref25.theme;
  return theme.modal[skin || 'with-form'].header.desktop.textAlign;
}, function (_ref26) {
  var skin = _ref26.skin,
      theme = _ref26.theme;
  return theme.modal[skin || 'with-form'].header.desktop.color;
});
export var CustomButton = styled(Button)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  background: transparent;\n  position: absolute;\n  top: 4px;\n  right: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n  line-height: 1;\n\n  &:focus{\n    outline: transparent;\n  }\n  \n  @media (min-width: ", "){\n    top: 12px;\n    right: 12px;\n  }\n"])), function (_ref27) {
  var theme = _ref27.theme;
  return theme.screen.smMin;
});
export var ModalBody = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: relative;\n  padding: 0px 4px;\n  line-height:1.75rem;\n  \n  @media (min-width: ", "){\n    padding: 0px 36px;\n    flex: 1 1 auto;\n  }\n"])), function (_ref28) {
  var theme = _ref28.theme;
  return theme.screen.smMin;
});
export var ModalFooter = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  padding: 0 0 48px;\n"])));